import React, { useEffect, useRef } from 'react';

import { Box } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { clearClickThroughView, INSIGHT_VIEWS } from 'reducers/okrsPageSlice';
import { useSelectedView } from 'reducers/viewsSlice';
import { okrsInsightsSelector } from 'selectors/okrsInsightsSelector';

import { TableAndFiltersContainer } from '../index';
import ClickThroughIndividualTable from './ClickThroughIndividualTable';
import ClickThroughObjectiveTable from './ClickThroughObjectiveTable';

const ClickThroughView = () => {
  const { viewType } = useSelector(okrsInsightsSelector);
  const selectedCohort = useSelectedView();

  const firstUpdate = useRef(true);

  const dispatch = useDispatch();

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    dispatch(clearClickThroughView());
  }, [dispatch, selectedCohort]);

  useEffect(
    () => () => {
      dispatch(clearClickThroughView());
    },
    [dispatch]
  );

  return (
    <Box>
      <TableAndFiltersContainer>
        {viewType === INSIGHT_VIEWS[0].value ? (
          <ClickThroughIndividualTable selectedCohort={selectedCohort} />
        ) : (
          <ClickThroughObjectiveTable selectedCohort={selectedCohort} />
        )}
      </TableAndFiltersContainer>
    </Box>
  );
};

export default ClickThroughView;
